'use strict';

import React from 'react';

require('styles/Loading.scss');

class LoadingComponent extends React.Component {
  constructor(props) {
    super(props);
    this.loadMore = this.loadMore.bind(this)
  }
  loadMore() {
    if (this.props.loadMore) {
      this.props.loadMore()
    }
  }
  render() {
    let loading = null;
    if(this.props.loading) {
      loading = <div className="loading-component">
        <i className="fa fa-spinner mr-20" aria-hidden="true"></i>
        {this.props.loadingWord || '加载中...'}
      </div>
    } else {
      loading = <div className="loading-component">
        <span onClick={this.loadMore}>点击加载更多</span>
      </div> 
    } 
    
    if(this.props.hasMore === false) {
      loading = (
        <div className="loading-component">
          <span className="text-gray">{this.props.noMoreWord || '没有更多了...'}</span>
        </div>
      );
    }
    return loading;
  }
}

LoadingComponent.displayName = 'LoadingComponent';
export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/components/LoadingComponent.js